import { FiShoppingCart, FiGlobe, FiLayers, FiTrendingUp } from "react-icons/fi";
import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCreditCard, LuLayoutDashboard, LuPalette, LuRocket, LuShoppingBag, LuStore, LuUsers } from "react-icons/lu";

export const ecommerceCmsBenefits = [
  {
    icon: <FiShoppingCart className="w-8 h-8" />,
    title: "Seamless Shopping Experience",
    desc: "Optimized storefronts for high conversion, fast checkout, and mobile-first design.",
  },
  {
    icon: <FiGlobe className="w-8 h-8" />,
    title: "Global Scalability",
    desc: "Multi-currency, multi-language, and region-specific features for international growth.",
  },
  {
    icon: <FiLayers className="w-8 h-8" />,
    title: "Flexible Integrations",
    desc: "Connect payment gateways, shipping, ERP, and marketing tools with ease.",
  },
  {
    icon: <FiTrendingUp className="w-8 h-8" />,
    title: "Growth-Driven Analytics",
    desc: "Built-in analytics and reporting to track sales, user behavior, and optimize performance.",
  },
];

export const ecommerceCmsServices = [
  {
    icon: <img src="/images/icons/magneto.webp" alt="Magento" className="w-8 h-8" />,
    title: "Magento Ecommerce Development",
    description: "Powerful Magento ecommerce solutions built for scalability, performance, and enterprise-grade functionality.",
    image: "/images/ecommerce_and_Cms_Services/MagnetoDevelopment.webp",
    link: "/magento-development-india",
    points: ["Custom Ecommerce Solutions", "High Performance Stores", "Ongoing Support"],
  },
  {
    icon: <img src="/images/icons/shopify.webp" alt="Shopify" className="w-8 h-8" />,
    title: "Shopify Store Development",
    description: "Custom Shopify stores designed for seamless online selling, scalability, and business growth.",
    image: "/images/ecommerce_and_Cms_Services/ShopifyDevelopment.webp",
    link: "/shopify-development-india",
    points: ["Custom Store Development", "Fast & Responsive Design", "Ongoing Support"],
  },
  {
    icon: <img src="/images/icons/woocommerce.webp" alt="WooCommerce" className="w-8 h-8" />,
    title: "WooCommerce Ecommerce Development",
    description: "Flexible WooCommerce solutions for secure, scalable, and feature-rich online stores.",
    image: "/images/ecommerce_and_Cms_Services/woocommercedevelopment.webp",
    link: "/woocommerce-development-india",
    points: ["Custom WooCommerce Setup", "Secure Payment Integration", "Ongoing Support"],
  },
  {
    icon: <img src="/images/icons/wordP.webp" alt="WordPress" className="w-8 h-8" />,
    title: "WordPress CMS Development",
    description: "Custom WordPress CMS solutions with flexible content management and powerful ecommerce capabilities.",
    image: "/images/ecommerce_and_Cms_Services/wordpressdevelopment.webp",
    link: "/wordpress-development-india",
    points: ["Custom CMS Development", "SEO Friendly Structure", "Ongoing Support"],
  },
];

export const ecommerceCmsProcessSteps = [
  {
    step: "01",
    title: "Discovery & Strategy",
    description: "Understand your business, target audience, and goals to craft a tailored ecommerce roadmap.",
    points: ["Market research", "Platform selection", "Feature planning"],
  },
  {
    step: "02",
    title: "Design & Prototyping",
    description: "Create wireframes and high-fidelity designs for a seamless, branded shopping experience.",
    points: ["UX/UI design", "Mobile-first approach", "Interactive prototypes"],
  },
  {
    step: "03",
    title: "Development & Integration",
    description: "Build robust, scalable stores with custom features and third-party integrations.",
    points: ["Custom modules", "API integrations", "Payment & shipping setup"],
  },
  {
    step: "04",
    title: "Testing & Launch",
    description: "Thorough QA, performance optimization, and go-live support for a flawless launch.",
    points: ["Cross-browser testing", "Load testing", "Launch checklist"],
  },
  {
    step: "05",
    title: "Growth & Support",
    description: "Ongoing maintenance, analytics, and enhancements to drive sales and customer loyalty.",
    points: ["Performance monitoring", "Feature updates", "24/7 support"],
  },
];

export const ecommerceCmsFaqs = [
  {
    q: "Which ecommerce platform is right for my business?",
    a: "We help you choose the best-fit platform—Magento, Shopify, WooCommerce, or WordPress—based on your goals, scale, and budget.",
  },
  {
    q: "Can you migrate my existing store?",
    a: "Yes, we offer seamless migration services with zero data loss and minimal downtime.",
  },
  {
    q: "Do you provide custom integrations?",
    a: "Absolutely. We integrate payment gateways, shipping providers, CRMs, ERPs, and more.",
  },
  {
    q: "Will my store be mobile-friendly?",
    a: "Every store we build is fully responsive and optimized for all devices.",
  },
  {
    q: "Do you offer ongoing support?",
    a: "Yes, we provide maintenance, updates, and growth consulting to keep your store ahead.",
  },
];
export const commerceTechStack = ["Shopify", "WooCommerce", "Magento", "WordPress", "Strapi", "Contentful", "Drupal", "Sanity"];
export const commerceTechIcons = {
  Shopify: "/images/icons/shopify.webp",
  WooCommerce: "/images/icons/woocommerce.webp",
  Magento: "/images/icons/magento.webp",
  WordPress: "/images/icons/wordpress.webp",
  Strapi: "/images/icons/strapi.webp",
  Contentful: "/images/icons/contentful.webp",
  Drupal: "/images/icons/drupal.webp",
  Sanity: "/images/icons/sanity.webp",
};

export const ecommerceHeroData = {
  backgroundImage: "/images/serviceBanners/ecommerceAndCMSLatest.webp",
  whiteImage: "/images/serviceBanners/E commerceCMSLatestW.webp",
  subTitle: " Create Scalable E-com CMS Solutions",
  title: (
    <>
      Build & Scale <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">E-com & CMS</span> <br /> Solutions
    </>
  ),
  description:
    "We build fast, responsive, and scalable ecommerce and CMS solutions that enhance user experience, streamline content management, and help businesses grow with strong digital performance and conversion focused design.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Performance Ecommerce CMS",
      desc: "Fast and optimized ecommerce CMS solutions.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Responsive Ecommerce CMS Design",
      desc: "Mobile-friendly layouts for all devices.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Secure Ecommerce CMS Development",
      desc: "Safe and reliable ecommerce platform setup.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Scalable CMS Solutions",
      desc: "Built to grow with your business needs.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "6%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "14%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "20%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const EcomSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Scalable Ecommerce CMS Solutions for Every Business Need",
  buildCards: [
    {
      title: "Custom Ecommerce CMS Platforms",
      desc: "Scalable ecommerce and CMS solutions built for growing businesses.",
      icon: LuShoppingBag,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Enterprise Ecommerce Solutions",
      desc: "Secure and high-performance platforms for enterprise business needs.",
      icon: LuBuilding2,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Ecommerce Store Development",
      desc: "Feature-rich online stores with seamless shopping experience.",
      icon: LuStore,
      colorClass: "text-[#22d3ee]",
      bgClass: "bg-[#22d3ee]/10",
      borderClass: "border-[#22d3ee]/20 hover:border-[#22d3ee]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(34,211,238,0.25)]",
    },
    {
      title: "On-Demand Ecommerce Solutions",
      desc: "Custom ecommerce platforms for booking, delivery, and service businesses.",
      icon: LuClock,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Secure Payment & CMS Integration",
      desc: "Reliable payment systems with advanced CMS functionality.",
      icon: LuCreditCard,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Custom Ecommerce CMS Solutions",
      desc: "Tailored ecommerce and CMS development based on your business goals.",
      icon: LuPalette,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Our Proven Ecommerce CMS Development Process",
  processTitle: "Our Strategic Ecommerce CMS Development Approach",
  processSteps: [
    {
      step: "01",
      title: "Discovery",
      description: "We understand your ecommerce business goals and CMS requirements.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Planning",
      description: "We define ecommerce features, CMS functionality, and project roadmap.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "UI/UX Design",
      description: "We create user-friendly ecommerce and CMS interfaces for better engagement.",
      icon: LuLayoutDashboard,
    },
    {
      step: "04",
      title: "Development",
      description: "We build scalable ecommerce CMS solutions with clean and optimized code.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Testing",
      description: "We ensure secure, fast, and error-free ecommerce platform performance.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Deployment",
      description: "We launch and maintain your ecommerce CMS platform with ongoing support.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE ECOMMERCE CMS SOLUTIONS?",
  benefitsTitle: "Why Ecommerce CMS Solutions are the Right Choice",
  benefits: [
    "Easy product & content management",
    "Faster ecommerce store development",
    "Responsive and user-friendly design",
    "Secure payment & CMS integration",
    "Scalable ecommerce architecture",
    "SEO-friendly ecommerce platform",
    "Customizable ecommerce solutions",
    "Cost-effective CMS development",
  ],
  logoImage: "/images/serviceBanners/ecommerceAndCMSLatest.webp",
  whiteLogoImage: "/images/serviceBanners/E commerceCMSLatestW.webp",
};

export const ecommerceCmsAboutData = [
  {
    title: "Scalable Ecommerce & CMS Platforms for Digital Businesses",
    content: (
      <>
        Modern businesses require flexible digital platforms that support seamless online operations and long-term scalability. Professional{" "}
        <b className="text-text-primary font-semibold">ecommerce development services</b> help brands create conversion-focused digital stores and content-driven platforms that
        improve customer experience and strengthen online business growth. A trusted <b className="text-text-primary font-semibold">cms development company</b> focuses on building
        scalable digital ecosystems that support business expansion, product management, and smooth website administration.
      </>
    ),
  },

  {
    title: "Custom Ecommerce Solutions for Growing Brands",
    content: (
      <>
        Every business operates with different customer expectations and operational goals, which makes{" "}
        <b className="text-text-primary font-semibold">ecommerce website development</b> essential for creating personalized online experiences. Businesses looking for
        enterprise-level flexibility often choose providers offering{" "}
        <a href="https://tychotechnologies.com/magento-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          magento development services
        </a>{" "}
        to build scalable ecommerce platforms capable of handling large product catalogs, advanced workflows, and growing customer demands across competitive markets.
      </>
    ),
  },

  {
    title: "Modern CMS Development with Flexible Technologies",
    content: (
      <>
        Content management platforms play an important role in maintaining digital visibility and operational efficiency. Businesses investing in{" "}
        <b className="text-text-primary font-semibold">shopify and wordpress development</b> benefit from flexible website management, simplified content publishing, and scalable
        ecommerce functionality. Companies also collaborate with experts providing{" "}
        <a href="https://tychotechnologies.com/shopify-development-india" className="text-cyan-400 underline hover:text-cyan-300">
          shopify development services
        </a>{" "}
        to create user-focused online stores with streamlined management systems and modern digital experiences tailored for long-term business growth.
      </>
    ),
  },

  {
    title: "Reliable Ecommerce Development Services in India",
    content: (
      <>
        The demand for advanced ecommerce and CMS platforms continues to grow across retail, healthcare, education, fintech, and enterprise industries. Businesses searching for
        scalable digital commerce solutions often choose an experienced <b className="text-text-primary font-semibold">ecommerce development company in india</b> for strategic
        development expertise and future-ready platform architecture. Companies also rely on professional{" "}
        <b className="text-text-primary font-semibold">cms development services india</b> providers to improve digital operations, strengthen customer engagement, and support
        sustainable online business growth.
      </>
    ),
  },
];

export const EcomPortfolioData = {
  subtitle: "OUR WORK",
  title: "E-commerce  We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
